<div class="w-full flex align-items-center justify-content-center bg-center bg-cover border-bottom-1 border-primary"
    style="background: linear-gradient(135deg, #000000 0%, #1a1a1a 50%, #36DEFB 100%); min-height: 22rem;">
    <div class="flex flex-column justify-content-center align-items-center text-center px-4 py-6">
        <h1 class="text-white text-5xl md:text-6xl lg:text-7xl font-bold mb-3">Snapcart</h1>
        <p class="text-gray-300 text-xl mb-4">Free local edition: BMS Items, BMS Ecom and BMS Ledger on your own computer</p>
        <ul class="list-none flex align-items-center justify-content-center p-0 m-0 mb-5 flex-wrap">
            <li><a routerLink="/" class="text-white text-lg font-light hover:text-primary no-underline">Home</a></li>
            <li class="mx-2"><i class="pi pi-angle-double-right text-white text-lg font-light"></i></li>
            <li><a routerLink="/free-software" class="text-white text-lg font-light hover:text-primary no-underline">Free software</a></li>
            <li class="mx-2"><i class="pi pi-angle-double-right text-white text-lg font-light"></i></li>
            <li><span class="text-primary text-lg font-light">Snapcart</span></li>
        </ul>
        <div class="flex gap-3 justify-content-center flex-wrap">
            <a pButton label="Download the kit (zip)" icon="pi pi-download" [href]="links.kitZip"
                class="p-button-primary p-button-rounded px-5 py-3 font-bold no-underline"></a>
            <a pButton label="Watch the live demo" icon="pi pi-play" href="/snapcart#live-demo" (click)="$event.preventDefault(); scrollTo('live-demo')"
                class="p-button-outlined p-button-secondary text-white border-white p-button-rounded px-5 py-3 font-bold no-underline"></a>
            <a pButton label="Request access" icon="pi pi-envelope" [routerLink]="links.requestAccess.path" [queryParams]="links.requestAccess.query"
                class="p-button-outlined p-button-secondary text-white border-white p-button-rounded px-5 py-3 font-bold no-underline"></a>
        </div>
    </div>
</div>

<!-- FEATURES -->
<section class="bg-white py-8" data-prerender>
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1400px;">
        <div class="text-center mb-6">
            <span class="text-primary-deep font-bold text-lg uppercase tracking-widest block mb-3">What you get</span>
            <h2 class="text-900 text-4xl font-bold">Three applications, one machine</h2>
        </div>
        <div class="grid">
            <div class="col-12 lg:col-4 p-3" *ngFor="let app of apps">
                <div class="bg-gray-50 border-1 border-gray-200 border-round-3xl p-5 h-full">
                    <div class="flex align-items-center gap-3 mb-4">
                        <div class="w-4rem h-4rem bg-primary-alpha-10 border-round-2xl flex align-items-center justify-content-center flex-shrink-0">
                            <i [class]="app.icon + ' text-primary text-3xl'"></i>
                        </div>
                        <div>
                            <h3 class="text-900 text-2xl font-bold m-0">{{ app.name }} <span class="text-primary-deep text-lg font-normal">{{ app.tag }}</span></h3>
                            <span class="text-700">{{ app.url }}</span>
                        </div>
                    </div>
                    <ul class="list-none p-0 m-0 mb-4">
                        <li class="flex align-items-start gap-2 mb-2 text-700 line-height-3" *ngFor="let f of app.features">
                            <i class="pi pi-check text-primary mt-1"></i><span>{{ f }}</span>
                        </li>
                    </ul>
                    <a [href]="app.jar" class="text-primary-deep font-medium no-underline hover:underline word-break-all">
                        <i class="pi pi-download mr-2"></i>{{ app.jarName }} ({{ app.size }})</a>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- LIVE DEMO -->
<section id="live-demo" class="bg-gray-900 py-8 relative overflow-hidden">
    <div class="absolute top-0 left-0 w-full h-full opacity-10"
        style="background-image: radial-gradient(circle at 2px 2px, #36DEFB 1px, transparent 0); background-size: 30px 30px;"></div>
    <div class="mx-auto px-4 md:px-6 lg:px-8 relative z-1" style="max-width: 1400px;">
        <div class="text-center mb-5">
            <span class="text-primary font-bold text-lg uppercase tracking-widest block mb-3">Live demo</span>
            <h2 class="text-white text-4xl font-bold mb-3">See the apps before you install anything</h2>
            <p class="text-gray-400 text-lg line-height-3 mx-auto m-0" style="max-width: 46rem;">Real screens of the local edition running on a laptop with a sample supermarket catalog and orders. No sign-in, nothing to download: click through the screens below.</p>
        </div>
        <div class="selector-row" role="tablist" aria-label="Application">
            <button *ngFor="let t of demoTours" type="button" role="tab" [attr.aria-selected]="t.id === demoApp"
                class="os-tab" [class.os-tab--active]="t.id === demoApp" (click)="selectDemoApp(t.id)">
                <i [class]="t.icon + ' mr-2'"></i>{{ t.label }}
            </button>
        </div>
        <div class="demo-viewer" tabindex="0" (keydown.arrowLeft)="demoStep(-1)" (keydown.arrowRight)="demoStep(1)" aria-live="polite">
            <div class="demo-frame">
                <img [src]="demoScreen.img" [alt]="demoScreen.title + ' — ' + demoScreen.caption" width="1440" height="900" loading="lazy" decoding="async">
                <button type="button" class="demo-nav demo-nav--prev" (click)="demoStep(-1)" aria-label="Previous screen"><i class="pi pi-chevron-left"></i></button>
                <button type="button" class="demo-nav demo-nav--next" (click)="demoStep(1)" aria-label="Next screen"><i class="pi pi-chevron-right"></i></button>
            </div>
            <div class="demo-caption">
                <span class="demo-counter">{{ demoIndex + 1 }} / {{ demoScreens.length }}</span>
                <div>
                    <h3 class="text-white text-xl font-bold mt-0 mb-1">{{ demoScreen.title }}</h3>
                    <p class="text-gray-400 line-height-3 m-0">{{ demoScreen.caption }}</p>
                </div>
            </div>
            <div class="demo-thumbs" role="tablist" aria-label="Screens">
                <button *ngFor="let sc of demoScreens; let i = index" type="button" role="tab" class="demo-thumb"
                    [class.demo-thumb--active]="i === demoIndex" [attr.aria-selected]="i === demoIndex" [attr.aria-label]="sc.title" (click)="demoGo(i)">
                    <img [src]="sc.img" alt="" width="160" height="100" loading="lazy" decoding="async">
                    <span>{{ sc.title }}</span>
                </button>
            </div>
        </div>
        <p class="text-gray-400 text-center mt-5 mb-0">Captured from the same jars you download, seeded with sample data. Want it on your own machine?
            <a href="/snapcart#setup" (click)="$event.preventDefault(); scrollTo('setup')" class="text-primary-deep no-underline hover:underline">Jump to the setup steps</a>.</p>
    </div>
</section>

<!-- WHAT IS OFF -->
<section class="bg-gray-100 py-6">
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1200px;">
        <div class="bg-white border-left-3 border-primary border-round-xl p-5 shadow-1">
            <h2 class="text-900 text-2xl font-bold mb-3"><i class="pi pi-info-circle text-primary mr-2"></i>What is off in the local edition, by design</h2>
            <p class="text-600 mb-3">Everything in the catalog and order flow works. These parts of the hosted product are not in the kit:</p>
            <ul class="text-700 line-height-3 pl-4 m-0">
                <li class="mb-2" *ngFor="let o of offList">{{ o }}</li>
            </ul>
        </div>
    </div>
</section>

<!-- PREREQUISITES -->
<section class="bg-white py-8">
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1400px;">
        <div class="text-center mb-6">
            <span class="text-primary-deep font-bold text-lg uppercase tracking-widest block mb-3">Before you start</span>
            <h2 class="text-900 text-4xl font-bold">Prerequisites</h2>
        </div>
        <div class="grid">
            <div class="col-12 md:col-6 lg:col-3 p-3" *ngFor="let p of prerequisites">
                <div class="border-1 border-gray-200 border-round-2xl p-4 h-full">
                    <h3 class="text-900 text-xl font-bold mb-2">{{ p.title }}</h3>
                    <p class="text-600 line-height-3 m-0" [innerHTML]="p.html"></p>
                </div>
            </div>
        </div>
    </div>
</section>

<!-- STEPS -->
<section id="setup" class="bg-gray-900 py-8 relative overflow-hidden">
    <div class="absolute top-0 left-0 w-full h-full opacity-10"
        style="background-image: radial-gradient(circle at 2px 2px, #36DEFB 1px, transparent 0); background-size: 30px 30px;"></div>
    <div class="mx-auto px-4 md:px-6 lg:px-8 relative z-1" style="max-width: 1000px;">
        <div class="text-center mb-6">
            <span class="text-primary font-bold text-lg uppercase tracking-widest block mb-3">Download, install, run</span>
            <h2 class="text-white text-4xl font-bold">Step by step</h2>
        </div>
        <div class="selector-row" role="tablist" aria-label="Operating system">
            <span class="selector-label">System</span>
            <button *ngFor="let o of osOptions" type="button" role="tab" [attr.aria-selected]="o.id === os"
                class="os-tab" [class.os-tab--active]="o.id === os" (click)="selectOs(o.id)">
                <i [class]="o.icon + ' mr-2'"></i>{{ o.label }}
            </button>
        </div>
        <div class="selector-row" role="tablist" aria-label="Database">
            <span class="selector-label">Database</span>
            <button *ngFor="let o of dbOptions" type="button" role="tab" [attr.aria-selected]="o.id === db"
                class="os-tab" [class.os-tab--active]="o.id === db" (click)="selectDb(o.id)">
                <i [class]="o.icon + ' mr-2'"></i>{{ o.label }}
            </button>
        </div>
        <div class="selector-row" role="tablist" aria-label="Run mode">
            <span class="selector-label">Apps</span>
            <button *ngFor="let o of runOptions" type="button" role="tab" [attr.aria-selected]="o.id === run"
                class="os-tab" [class.os-tab--active]="o.id === run" (click)="selectRun(o.id)">
                <i [class]="o.icon + ' mr-2'"></i>{{ o.label }}
            </button>
        </div>
        <p class="text-gray-400 text-center mb-6">Showing the steps for <strong class="text-white">{{ summary }}</strong>. Change any choice above and the steps update.</p>
        <div class="flex gap-4 mb-5" *ngFor="let s of steps; let i = index">
            <div class="w-3rem h-3rem flex-shrink-0 border-circle bg-primary text-900 flex align-items-center justify-content-center text-xl font-bold">{{ i + 1 }}</div>
            <div class="flex-grow-1 min-w-0">
                <h3 class="text-white text-xl font-bold mt-2 mb-2">{{ s.title }}</h3>
                <p class="text-gray-400 line-height-3 mb-2" [innerHTML]="s.html"></p>
                <pre *ngIf="s.code" class="code-block">{{ s.code }}</pre>
                <div *ngFor="let opt of s.options" class="mt-3 pl-3 border-left-2 border-primary">
                    <h4 class="text-white text-lg font-bold mt-0 mb-1">{{ opt.label }}</h4>
                    <p class="text-gray-400 line-height-3 mb-2" [innerHTML]="opt.html"></p>
                    <pre class="code-block">{{ opt.code }}</pre>
                </div>
            </div>
        </div>
        <p class="text-gray-400 text-center m-0">The kit's README carries the same steps plus the "Own MySQL" variant.
            <a [href]="links.kitZip" class="text-primary-deep no-underline hover:underline">Download the kit</a>.</p>
    </div>
</section>

<!-- TROUBLESHOOTING -->
<section class="bg-white py-8">
    <div class="mx-auto px-4 md:px-6 lg:px-8" style="max-width: 1200px;">
        <div class="text-center mb-6">
            <span class="text-primary-deep font-bold text-lg uppercase tracking-widest block mb-3">If something goes wrong</span>
            <h2 class="text-900 text-4xl font-bold">Troubleshooting</h2>
        </div>
        <div class="overflow-x-auto">
            <table class="ts-table w-full">
                <thead><tr><th>Symptom</th><th>Cause / fix</th></tr></thead>
                <tbody>
                    <tr *ngFor="let t of troubleshooting"><td class="font-medium text-900">{{ t.symptom }}</td><td class="text-700">{{ t.fix }}</td></tr>
                </tbody>
            </table>
        </div>
    </div>
</section>

<!-- CTA -->
<section class="bg-gray-900 py-6 relative overflow-hidden">
    <div class="absolute top-0 left-0 w-full h-full opacity-20" style="background: radial-gradient(circle at center, #36DEFB 0%, transparent 70%);"></div>
    <div class="mx-auto px-4 md:px-6 lg:px-8 text-center relative z-1" style="max-width: 1000px;">
        <h2 class="text-white text-3xl md:text-5xl font-bold mb-4 mt-0 lg:mt-6">Ready to run Snapcart?</h2>
        <p class="text-gray-400 text-lg mb-4 mx-auto line-height-3">Send us your MAC address through the contact form. Within one business day you receive by e-mail:</p>
        <ul class="list-none p-0 m-0 mb-6 inline-block text-left text-gray-300 line-height-3">
            <li class="mb-2"><i class="pi pi-check text-primary mr-2" aria-hidden="true"></i>the licence file for that machine (<code>config/lic/ecs-sass-lcp.lic</code>)</li>
            <li class="mb-2"><i class="pi pi-check text-primary mr-2" aria-hidden="true"></i>a sign-in account: username and a temporary password</li>
            <li><i class="pi pi-check text-primary mr-2" aria-hidden="true"></i>the link to the kit and to this guide</li>
        </ul>
        <div class="flex gap-3 justify-content-center flex-wrap mb-5">
            <button pButton label="Request access" icon="pi pi-envelope" iconPos="right" [routerLink]="links.requestAccess.path" [queryParams]="links.requestAccess.query"
                class="p-button-primary p-button-rounded px-6 py-3 font-bold shadow-4"></button>
        </div>
    </div>
</section>
